<template>
<div class="chapter">
<div class="inner_page">
<a id="pvii"></a>
<div class="timebreak "> </div>
<div class="timebreak "> </div>
<div class="timebreak "> </div>
<div class="timebreak "> </div>
<blockquote>
<p class="center "><em>To my mom and dad, Claudine and Enerchius Osmond, who loved me</em></p>
</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front02.vue?1016567e